import React, { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { toast } from "react-toastify";

// import JS files
import useFetch from "../../../../context/useFetch";
import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";
import PanelFilter from "../../../shares/PanelFilter";
import MuiPagination from "../../../shares/MuiPagination";
import PanelTable from "../../../shares/PanelTable";
import AddCity from "./AddCity";
import EditCity from "./EditCity";
import RemoveCity from "./RemoveCity";

const City = (props) => {
  const headersList = [
    { colName: "name", name: "نام شهر" },
    { colName: "edit", name: "ویرایش" },
    { colName: "remove", name: "حذف" },
  ];
  const mobileHeadersList = [{ colName: "name", name: "نام شهر" }];

  const dataKey = ["name"];

  let windowWidth = window.screen.width;

  const [openAddCityModal, setOpenAddCityModal] = useState(false);
  const handleAddCityModal = () => {
    setOpenAddCityModal((before) => !before);
  };

  const [isFilterOn, setIsFilterOn] = useState(false);
  const [nameFilter, setNameFilter] = useState(null);

  const [citiesList, setCitiesList] = useState({ results: [] });

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const getCitiesApi = useFetch({
    method: "get",
    url: "City_Service",
    params: { name: nameFilter },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setCitiesList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  // Filter
  const filterList = [
    {
      type: "textField",
      label_fa: "نام",
      label_en: "name",
      state: nameFilter,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "name") setNameFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (nameFilter !== null) {
      setIsFilterOn(true);
      getCitiesApi.reFetch();
    }
  };

  const reset_filter = () => {
    setNameFilter(null);
    getCitiesApi.reFetch();
  };
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setCitiesList({ results: [] });

    getCitiesApi.reFetch();
  };

  const buttonsList = [
    {
      label: "ویرایش",
      component: (it) => (
        <EditCity selectedRow={it} getCitiesApi={getCitiesApi} />
      ),
    },
  ];
  const actionsList = [
    {
      label: "حذف",
      component: (it) => (
        <RemoveCity selectedRow={it} getCitiesApi={getCitiesApi} />
      ),
    },
  ];

  return (
    <>
      <PanelTemplate sidebarActiveLink="cities">
        <>
          <div className="panel-main-header">
            <span>مدیریت شهرها</span>
          </div>
          <div className="add-item-container">
            <span className="text">
              برای اضافه کردن شهر جدید روی دکمه افزودن کلیک کنید.
            </span>
            <MuiButton
              onClick={handleAddCityModal}
              variant="outlined"
              icon={<AddIcon />}
              color="secondary"
              text="افزودن"
            />
          </div>
          {openAddCityModal && (
            <AddCity
              openModal={openAddCityModal}
              setOpenModal={setOpenAddCityModal}
              getFunc={getCitiesApi}
            />
          )}
          <PanelFilter
            header="فیلتر شهرها:"
            list={filterList}
            update_filter={update_filter}
            filter={filter}
            reset_filter={reset_filter}
          />
          <>
            <PanelTable
              header="لیست شهرها:"
              headers={headersList}
              mobileHeaders={mobileHeadersList}
              data={citiesList.results}
              dataKey={dataKey}
              buttons={buttonsList}
              actions={actionsList}
              icon={<AccountBalanceIcon />}
            />

            <MuiPagination
              onChange={onChangePage}
              count={Math.ceil(
                paginationPageInfo.count / paginationPageInfo.pageSize
              )}
            />
          </>
        </>
      </PanelTemplate>
    </>
  );
};

export default City;
